import {useCallback, useEffect, useMemo, useState} from "react";
import {useOutletContext} from "react-router";
import {Typography, Box, useMediaQuery, useTheme} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {apiGet} from "../utils";
import {buildV2QueryParams} from "../utils/filters";
import {LoadingPanel} from "../utils/loading_spinner";
import {RfmSegmentGrid} from "../components/RfmSegmentGrid";
import {RfmBubbleChart} from "../components/RfmBubbleChart";
import {CustomerHealthTable} from "../components/CustomerHealthTable";

const RFM_ROW_CARD_HEIGHT = 520;

export const CustomerHealthContainer = () => {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const {filters} = useOutletContext();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedSegment, setSelectedSegment] = useState(null);

    const fetchCustomerHealth = useCallback(() => {
        setLoading(true);
        apiGet(`v2/customer-churn${buildV2QueryParams(filters)}`, (resp) => {
            if (resp.success && resp.data) {
                setData(resp.data);
            } else {
                console.error('Customer Health API error:', resp.error);
                setData({breakdown: [], segmentCounts: {}});
            }
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchCustomerHealth();
    }, [fetchCustomerHealth]);

    const filteredBreakdown = useMemo(() => {
        const rows = data?.breakdown || [];
        if (!selectedSegment) return rows;
        return rows.filter((row) => row.segment === selectedSegment);
    }, [data?.breakdown, selectedSegment]);

    if (loading) {
        return <LoadingPanel loading={true} message="Loading customer health..."/>;
    }

    return (
        <div style={{marginTop: 30, marginBottom: 100, marginLeft: 30, marginRight: 30}}>
            <Grid container spacing={2} style={{marginBottom: 16}} alignItems="stretch">
                <Grid size={{xs: 12, md: 4}} sx={{maxWidth: {md: 450}, width: '100%', display: 'flex', minHeight: 0}}>
                    <RfmSegmentGrid
                        segmentCounts={data?.segmentCounts || {}}
                        selectedSegment={selectedSegment}
                        onSelectSegment={setSelectedSegment}
                        compact
                        matrixWidth={360}
                        cardHeight={isMdUp ? RFM_ROW_CARD_HEIGHT : null}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 8}} sx={{minWidth: 0, display: 'flex', minHeight: 0}}>
                    <RfmBubbleChart
                        customers={data?.breakdown || []}
                        selectedSegment={selectedSegment}
                        cardHeight={isMdUp ? RFM_ROW_CARD_HEIGHT : null}
                    />
                </Grid>
            </Grid>

            <CustomerHealthTable
                breakdown={filteredBreakdown}
                calcConfigs={data?.calcConfigs}
                filters={filters}
            />
        </div>
    );
};
